import React, { useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text4 } from '../../../styles';
import { Input, Button, Statistic } from 'antd';
import moment from 'moment';


const OTPModal = (props) => {
    const [OTP, setOTP] = useState("");
    const [countdown, setCountdown] = useState(moment());
    const [showResetButton, setShowResetButton] = useState(false);
    const resetCountdown = () => setCountdown(moment().add(180, "seconds"));

    const handleResend = () => {
        props.generateOTP();
        setShowResetButton(false);
        resetCountdown();
    }

    const renderCountdown = () => showResetButton ?
        <Button className="m-0" type="link" size="small" onClick={handleResend}>Resend OTP</Button>
        :
        <Statistic.Countdown
            valueStyle={{ fontSize: 14, opacity: 0.8 }}
            value={countdown}
            format="mm:ss"
            onFinish={() => setShowResetButton(true)}
        />


    return (
        <EaseModal
            width={450}
            title={false}
            visible={props.visible}
            maskClosable={false}
            closable={false}
            centered
            hideFooter
            destroyOnClose
            onOpen={resetCountdown}
        >
            <Text4 className="d-block mb-4" >OTP has been sent to your registered email address and phone number. OTPs are valid for only 3 minutes.</Text4>
            <Text4 className="mb-2">Enter OTP:</Text4>
            <Input autoComplete='off' onChange={(e) => setOTP(e.target.value)} addonAfter={renderCountdown()} />
            <div className="mt-4 d-flex justify-content-end">
                <Button className="mr-1" onClick={props.onCancel}>Cancel</Button>
                <Button type="primary" loading={props.loading} onClick={() => props.verifyOTP(OTP)}>Submit</Button>
            </div>
        </EaseModal>
    )
};

export { OTPModal };